import { CloseButton, Table } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconEdit } from '@tabler/icons-react';
import { useMemo, useState } from 'react';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { formatToCurrency } from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { EditProductCostDto } from '../types/EditProductCostDto';
import type { ProductCostDto } from '../types/ProductCostDto';
import { EditProductCostModal } from './EditProductCostModal';
import { KeyedRow } from '../../../components/KeyedRow';

interface ProductCostProps {
	product: ProductCostDto;
}

export function ProductCostRow({ product }: ProductCostProps) {
	const [isOpen, { open, close }] = useDisclosure(false);
	const [editableProduct, setEditableProduct] = useState(product);

	const editProductCost: EditProductCostDto = useMemo(() => {
		return {
			skuid: editableProduct.skuid,
			caseCost: editableProduct.caseCost,
			caseQuantity: editableProduct.caseQuantity,
		};
	}, [editableProduct]);

	return (
		<>
			<EditProductCostModal
				editProductCost={editProductCost}
				close={close}
				opened={isOpen}
				updateTableValue={setEditableProduct}
			/>
			<KeyedRow>
				<Table.Td>{undefinedCheck(editableProduct.skuid)}</Table.Td>
				<Table.Td>{undefinedCheck(editableProduct.description)}</Table.Td>
				<Table.Td>{undefinedCheck(editableProduct.department)}</Table.Td>
				<Table.Td>{undefinedCheck(editableProduct.supplier)}</Table.Td>
				<Table.Td>{editableProduct.caseQuantity}</Table.Td>
				<Table.Td>{formatToCurrency(editableProduct.caseCost)}</Table.Td>
				<Table.Td>
					<CloseButton
						icon={<IconEdit {...defaultIconStyle} />}
						onClick={() => open()}
					/>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
